import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
export default function YoutubeView(props) {
  const [PreviewUrl, setPreviewUrl] = React.useState("")
  const location = useLocation();
  var videoid = location.pathname.slice(13)
  var youtubeid = window.atob(videoid)
  useEffect(() => {

  })
  const color = "#00000011"
  return (
    <div>
      <div style={{ position: "relative" }}>
        <div className='d-lg-block d-sm-none' style={{ position: "absolute", backgroundColor: color, height: 100, width: "30%" }} />
        <div className='d-lg-block d-sm-none' style={{ position: "absolute", backgroundColor: color,marginTop:"92vh", height: 100, width: "100%" }} />
        {/* <div className='d-lg-block d-sm-none' style={{ position: "absolute", backgroundColor: color, height: 100, width: "100%" }} /> */}
        <div style={{ alignContent: "right" }}>
          <div className='d-sm-none d-none'
            style={{
              position: "absolute",
              right: -30, bottom: 10, backgroundColor: color,
              height: 50, width: 70,
              justifyContent: "center",
              alignContent: "flex-end", alignItems: "flex-end"
            }}
          />
        </div>
        <div className='d-lg-none d-sm-none' style={{ position: "absolute", bottom: 10, backgroundColor: color, height: 50, width:"10px", justifyContent: "center", }} />

        <iframe
          style={{ width: "100vw", height: "100vh" }}
          src={
            `https://www.youtube.com/embed/${youtubeid}?rel=0`
          }
          onMouseDown={(e) => e.preventDefault()} onContextMenu={(e) => e.preventDefault()}
          sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation"
        >
        </iframe>
        {/* <iframe
          style={{ width: "100vw", height: "100vh" }}
          src={`https://www.youtube-nocookie.com/embed/${youtubeid}?rel=0`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        /> */}
       
      </div>

    </div>
  

  )
}
